// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"bc3aee0b","856":"ed95e9a1","960":"8259208c"}[chunkId] + ".chunk.js";
};